module.exports = __webpack_public_path__ + "images/emoji/blue_heart.9699a650edfea0f57f7b.png";